export default {
    RespostaDeNominata: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "resposta-de-nominata"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/RespostaDeNominata.js
// module id = 6HYd
// module chunks = 18